import { render } from "./ComingSoonCard.vue?vue&type=template&id=307f20d0"
import script from "./ComingSoonCard.vue?vue&type=script&lang=js"
export * from "./ComingSoonCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__